import Image from 'next/image';
import React, { useState } from 'react';
import { Map } from '../../map';
import { Marker, Popup, Layer, Source } from '@urbica/react-map-gl';
import { motion } from 'framer-motion';
import { useRouter } from 'next/router';
import getAmplitude from '../../../utils/amplitude';

type Props = {
  viewport: {
    latitude: number;
    longitude: number;
    zoom: number;
  };
  dataset: any;
  geojson?: any;
  startingPoint?: any;
  endingPoint?: any;
};

const getStartingPoint = coords => {
  return (
    <>
      <Marker key={'startingPoint'} longitude={coords[0]} latitude={coords[1]} fill>
        <motion.div
          style={{
            width: 24,
            height: 24,
            borderRadius: 24,
            border: `2px solid #FBBA008a`,
          }}></motion.div>
      </Marker>
      <Marker key={'startingPoint'} longitude={coords[0]} latitude={coords[1]} fill>
        <motion.div
          style={{
            width: 20,
            height: 20,
            backgroundColor: `#FBBA00`,
            borderRadius: 20,
          }}></motion.div>
      </Marker>
    </>
  );
};

const getEndingPoint = coords => {
  return (
    <>
      <Marker key={'startingPoint'} longitude={coords[0]} latitude={coords[1]} fill>
        <motion.div
          style={{
            width: 24,
            height: 24,
            borderRadius: 24,
            border: `2px solid #FBBA008a`,
          }}></motion.div>
      </Marker>
      <Marker key={'startingPoint'} longitude={coords[0]} latitude={coords[1]} fill>
        <motion.div
          style={{
            width: 20,
            height: 20,
            backgroundColor: `#FBBA00`,
            borderRadius: 20,
          }}></motion.div>
      </Marker>
    </>
  );
};

const DetailMap: React.FC<Props> = ({ viewport, geojson, dataset, startingPoint, endingPoint }) => {
  const [hover, setHover] = useState(undefined);
  const router = useRouter();
  const { slug } = router.query;

  if (!viewport || !geojson || !dataset) return null;
  return (
    <div style={{ marginBottom: 32 }}>
      <Map viewport={viewport} style={{ width: '100%', height: 500 }}>
        {geojson?.features.map(point => (
          <Marker key={point.properties.id} longitude={point.geometry.coordinates[0]} latitude={point.geometry.coordinates[1]}>
            <motion.div
              onHoverStart={() => {
                setHover(point);
              }}
              onHoverEnd={() => {
                setHover(undefined);
              }}
              onClick={async () => {
                router.push(`/${slug}/attraction/${point.properties.slug ? point.properties.slug : point.properties.id}`);
                const amplitude = await getAmplitude();
                amplitude.logEvent('Clicked on map circle', { itemType: point.properties?.type });
              }}
              initial="rest"
              whileHover="hover"
              animate="rest"
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}>
              <motion.div
                variants={{
                  hover: {
                    scale: 1.5,
                  },
                  rest: {
                    scale: 1,
                  },
                }}
                style={{
                  width: 40,
                  height: 40,
                  borderRadius: 40,
                  border: `2px solid #FBBA00`,
                }}>
                <Image className="mapImage" width={150} height={150} src={point.properties.image} alt={point.properties.title} />
              </motion.div>
            </motion.div>
          </Marker>
        ))}
        <Source id="route" type="geojson" data={dataset} />
        {startingPoint && getStartingPoint(dataset.geometry.coordinates[0])}
        {endingPoint && getEndingPoint(dataset.geometry.coordinates[dataset.geometry.coordinates.length - 1])}
        <Layer
          id="route"
          type="line"
          source="route"
          layout={{
            'line-join': 'round',
            'line-cap': 'round',
          }}
          paint={{
            'line-color': `#FBBA00`,
            'line-width': 2,
          }}
        />
        {hover && (
          <Popup longitude={hover.geometry.coordinates[0]} latitude={hover.geometry.coordinates[1]} anchor={'bottom'} closeButton={false} offset={40}>
            {hover.properties.title}
          </Popup>
        )}
      </Map>
    </div>
  );
};

export default DetailMap;
